import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  },
  table: {
    width: '60%'
  },
  tableHead: {
    width: '100%'
  },
  tableHeadRow: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '2fr 2fr 2fr 3fr'
  },
  tableHeadCell: {
    color: `${theme.palette.grey[700]} !important`,
    display: 'flex',
    justifyContent: 'center',
    border: `1px solid ${theme.palette.grey[200]}` // Light grey borders between cells
  },
  tableCell: {
    border: `1px solid ${theme.palette.grey[200]}`, // Light grey borders between cells
    padding: theme.spacing(1),
    textAlign: 'center'
  },

  firstColumn: {
    backgroundColor: theme.palette.grey[200],
    border: `1px solid ${theme.palette.primary.contrastText}` // Light grey borders between cells
  },
  centeredTextField: {
    textAlign: 'center' // Center the text
  },
  noBorderTextField: {
    padding: theme.spacing(0.5),
    background: 'none',
    border: 'none',
    '& input': {
      padding: 0
    }
  },
  noBorderSelect: {
    padding: theme.spacing(0.5),
    '& .MuiSelect-select': {
      padding: 0
    },
    '&:before': {
      content: 'none' // Remove the underline
    },
    '&:after': {
      content: 'none' // Remove the underline on focus
    },
    '&:focus': {
      border: 'none',
      outline: 'none'
    }
  }
}))

export default useStyles
